import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../common/shared/services/auth.service';
import { UtilitiesService } from '../../../common/shared/services/utilities.service';
import { ResetPasswordCredentials } from '../../../common/models/reset-password-credentials';
import { ActivatedRoute } from '@angular/router';
import * as zxcvbn from 'zxcvbn';
import { environment } from '../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from '../../../common/shared/services/dialog.service';
import { NavigationService } from '../../../common/shared/services/navigation.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  resetPasswordMailsent = false;
  passwordReseted = false;
  isSendResetMail = true;
  hidePW = true;
  email = '';
  resetPasswordCredentials = new ResetPasswordCredentials();

  passwordStrength = 0;
  reCaptchaKey = '';
  reCaptchaValid = false;

  constructor(private _authService: AuthService,
              private _utilitiesService: UtilitiesService,
              private _dialogService: DialogService,
              private _navigationService: NavigationService,
              private _route: ActivatedRoute,
              private _translateService: TranslateService) { }

  ngOnInit() {
    this._authService.checkUserLoggedIn();

    this.reCaptchaKey = environment.reCaptchaKey;
    if (!this.reCaptchaKey || this.reCaptchaKey === '') {
      this.reCaptchaValid = true;
    }

    if (this._route.snapshot.queryParamMap.get('token') !== null) {
      this.resetPasswordCredentials.token = this._route.snapshot.queryParamMap.get('token');
      this.isSendResetMail = false;
    }

    this._utilitiesService.removeInitAction(0);
  }

  sendMail() {
    this._utilitiesService.addMinorAction('SendResetMail');
    this._authService.sendResetPasswordMail(this.email).subscribe(
      data => {
        this.resetPasswordMailsent = this._utilitiesService.getData(data);
        this._utilitiesService.removeAction('SendResetMail');
        if (this.resetPasswordMailsent) {
          this._translateService.get(['portal.ResetPassword.SendResetPasswordMail.Success']).subscribe((res: string) => {
            this._dialogService.showSuccessDialog(
              res['portal.ResetPassword.SendResetPasswordMail.Success']);
          });
        } else {
          this._translateService.get(['portal.ResetPassword.SendResetPasswordMail.Error']).subscribe((res: string) => {
            this._dialogService.showErrorDialogWithBody(res['portal.ResetPassword.SendResetPasswordMail.Error']);
          });
        }
      },
      err => {
        this._utilitiesService.handleErrors(err);
      }
    );
  }

  resetPassword() {
    this._utilitiesService.addMinorAction('ResetPassword');
    this._authService.resetPassword(this.resetPasswordCredentials).subscribe(
      data => {
        this.passwordReseted = this._utilitiesService.getData(data);
        this._utilitiesService.removeAction('ResetPassword');

        if (this.passwordReseted) {
          this._translateService.get(['portal.ResetPassword.ResetPassword.Success']).subscribe((res: string) => {
            this._dialogService.showSuccessDialogWithCallback(
              this.reDirectToLogin.bind(this),
              res['portal.ResetPassword.ResetPassword.Success']);
          });
        } else {
          this._translateService.get(['portal.ResetPassword.ResetPassword.Error']).subscribe((res: string) => {
            this._dialogService.showErrorDialogWithBody(res['portal.ResetPassword.ResetPassword.Error']);
          });
        }
      },
      err => {
        this._utilitiesService.handleErrors(err);
      }
    );
  }

  resetActionActive() {
    return this._utilitiesService.isActionActive('SendResetMail') || this._utilitiesService.isActionActive('ResetPassword');
  }

  updatePasswordStrength(): void {
    const results = zxcvbn(this.resetPasswordCredentials.password);
    this.passwordStrength = results.score;
  }

  handleCorrectCaptcha(event) {
    this.reCaptchaValid = true;
  }

  handleExpiredCaptcha() {
    this.reCaptchaValid = false;
  }

  getreCaptchaLanguage() {
    if (this._translateService.currentLang === 'se') {
      return 'sv';
    }
    return 'en';
  }

  reDirectToLogin() {
    this._navigationService.navigateTo('login');
  }
}
